import React from 'react'
import { Mail, Phone, MessageCircle } from "lucide-react";
import Header from '../components/Header'
import Footer from '../components/Footer'
import { motion } from "framer-motion"
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import ContactImg from "../media/ContactUs.jpg"

export default function ContactUs(){
    return (
        <>
            <Header />
            <main className="bg-white text-gray-800 overflow-hidden" >
                <section className="mt-16 md:mt-24 relative flex flex-col items-center justify-center h-[60vh] bg-cover bg-center" style = {{backgroundImage: `url(${ContactImg})`}}>
                    <motion.div
                    className="absolute inset-0"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                    
                    ></motion.div>
    
                    <motion.h1
                    className="relative text-black font-serif text-5xl md:text-6xl font-bold text-center"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.3 }}
                    >
                        Contact Us
                    </motion.h1>

                    {/* Email */}
                    <motion.a
                    href="mailto:info@yking.co"
                    className="relative flex items-center justify-center text-black underline text-lg md:text-2xl mt-6"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.6 }}
                    >
                        <Mail className="mr-2 w-6 h-6" />
                        info@yking.co
                    </motion.a>

                    {/* Phone + WhatsApp */}
                    <motion.a
                    href="tel:+923111108255"
                    className="relative flex items-center justify-center text-black underline text-lg md:text-2xl mt-4"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.9 }}
                    >
                        <Phone className="mr-2 w-6 h-6" />
                        +92 311 1108255
                    </motion.a>
                </section>
            </main>
            <Footer />
        </>
    )
}